import { DAY_MS as u } from "../../../../internal/Calendar/calendar/constants.js";
import { parseDate as c } from "../../../../../utils/datetime/main.js";
const i = (e, a = 0) => new Date(new Date(e).setUTCHours(0, 0, 0, 0) + Math.floor(a) * u), d = (e) => c(i(/* @__PURE__ */ new Date(), e)), l = (e) => e ? Math.ceil(e / 30) : null, f = (e, a) => {
  let t, n;
  function o(...r) {
    clearTimeout(t), n = r, t = setTimeout(() => {
      e(n), n = void 0;
    }, a);
  }
  return o.cancel = () => {
    t && (clearTimeout(t), t = void 0, n = void 0);
  }, o;
}, p = (e) => e / 100;
export {
  l as calculateMaximumRepaymentPeriodInMonths,
  f as debounce,
  d as getExpectedRepaymentDate,
  p as getPaymentRatePercentage
};
